export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS'
export const SET_GROUPS = 'SET_GROUPS'
export const ENABLE_SUBSCRIPTION = 'ENABLE_SUBSCRIPTION'
export const ENABLE_SUBSCRIPTIONS = 'ENABLE_SUBSCRIPTIONS'
export const DISABLE_SUBSCRIPTION = 'DISABLE_SUBSCRIPTION'
export const SET_LOADING_STATE = 'SET_LOADING_STATE'
